// On rehydration the backend wraps image attachments in
// `<vision_attachments>` blocks inside the user text. We undo the wrap
// so restored threads carry the same `[binary, text]` shape the live
// composer emits and the file-chip UI matches.

export type ParsedVisionBinary = {
  type: 'binary'
  url: string
  filename: string
  mimeType: string
}

const VISION_ATTACHMENTS_RE = /<vision_attachments>([\s\S]*?)<\/vision_attachments>\s*/g

// Backend line shape: `- <filename> (<mimetype>) — URL: <url>`
const VISION_ATTACHMENT_LINE_RE = /^-\s+(.+?)\s+\(([^)]+)\)\s+—\s+URL:\s+(\S+)\s*$/gm

export function extractVisionAttachments(rawText: string): {
  text: string
  binaryParts: ParsedVisionBinary[]
} {
  const binaryParts: ParsedVisionBinary[] = []

  for (const block of rawText.matchAll(VISION_ATTACHMENTS_RE)) {
    const body = block[1] ?? ''
    for (const line of body.matchAll(VISION_ATTACHMENT_LINE_RE)) {
      binaryParts.push({
        type: 'binary',
        filename: line[1] ?? '',
        mimeType: line[2] ?? '',
        url: line[3] ?? '',
      })
    }
  }

  const text = rawText.replace(VISION_ATTACHMENTS_RE, '').trim()
  return { text, binaryParts }
}
